'use client'

import { ChevronsUpDown } from 'lucide-react'
import BrFlag from '~/assets/flags/br'
import DeFlag from '~/assets/flags/de'
import EsFlag from '~/assets/flags/es'
import UsFlag from '~/assets/flags/us'

import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '~/components/ui/sidebar'
import { validateLanguage } from '~/i18n'

const languages = [
  {
    code: 'en',
    flag: <UsFlag />,
    name: 'English',
  },
  {
    code: 'br',
    flag: <BrFlag />,
    name: 'Portuguese',
  },
  {
    code: 'es',
    flag: <EsFlag />,
    name: 'Spanish',
  },
  {
    code: 'de',
    flag: <DeFlag />,
    name: 'German',
  },
]

export function NavLanguage() {
  const { isMobile } = useSidebar()
  const { i18n } = useTranslation()

  const [language, setLanguage] = useState(validateLanguage(i18n.language))

  const currentFlag = useMemo(() => {
    return languages.find((l) => l.code === language)?.flag
  }, [language])

  const changeLanguage = useCallback(
    (language: string) => {
      i18n.changeLanguage(language)
      setLanguage(language)
    },
    [i18n],
  )

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size='lg'
              className='data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground h-8'
            >
              {currentFlag}
              <div className='grid flex-1 text-left text-sm leading-tight'>
                <span className='truncate font-medium'>
                  {languages.find((l) => l.code === language)?.name}
                </span>
              </div>
              <ChevronsUpDown className='ml-auto size-2' />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className='w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg'
            side={isMobile ? 'bottom' : 'right'}
            align='end'
            sideOffset={4}
          >
            <DropdownMenuGroup>
              {languages.map((l) => (
                <DropdownMenuItem key={l.code} onClick={() => changeLanguage(l.code)}>
                  {l.flag}
                  {l.name}
                </DropdownMenuItem>
              ))}
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
